import React, { useEffect } from 'react';
import { Box, Grid } from '@mui/material';
import DatePickerCustom from '../../../../components/DatePicker/DatePickerCustom';
import { getWingsUnderDeptId } from '../../../../redux/features/generalSlice';
import { ogdDepartmentId } from '../../../../utils/constants/departmentDetails';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { ogdWings } from '../../../../utils/constants/GlobalStaticData';
import dayjs from 'dayjs';
import GlobalSelectFieldWithoutFormikNew from '../../../../components/mui/GlobalSelectFieldWithoutFormikNew';

const MonthlyWiseGlobalFilter = ({ fromDate, toDate, setFromDate, setToDate, selectedTeam, setSelectedTeam }) => {
  const wingsUnderDeptId = useSelector((state) => state.general.wingsUnderDeptId);
  const { data: wingsData } = wingsUnderDeptId;
  const dispatch = useDispatch();
  useEffect(() => {
    if (wingsData?.length === 0) {
      dispatch(getWingsUnderDeptId(ogdDepartmentId));
    }
  }, [wingsData]);
  const teams = wingsData?.map((wing) => ({ id: wing.wing_id, value: wing.wing_name })) || ogdWings;
  return (
    <Box
      sx={{
        backgroundColor: 'white',
        borderRadius: '10px',
        p: { xs: 0, md: 1.5 },
      }}
    >
      <Grid container spacing={{ xs: 1, md: 2 }}>
        <Grid item xs={4}>
          <DatePickerCustom
            label="From Date"
            value={dayjs(fromDate)}
            setValue={(date) => setFromDate(date.format('YYYY-MM-DD'))}
            viewDetails={['year', 'month', 'day']}
            fullWidth
            height={36}
            fontSize="0.75rem"
          />
        </Grid>

        <Grid item xs={4}>
          <DatePickerCustom
            label="To Date"
            value={dayjs(toDate)}
            setValue={(date) => setToDate(date.format('YYYY-MM-DD'))}
            viewDetails={['year', 'month', 'day']}
            fullWidth
            height={36}
            fontSize="0.75rem"
          />
        </Grid>

        <Grid item xs={4}>
          <GlobalSelectFieldWithoutFormikNew
            sx={{
              '& .MuiInputBase-root': {
                height: 36,
                fontSize: '0.75rem',
              },
            }}
            keys={{ itemId: 'id', itemValue: 'value' }}
            data={[{ id: -1, value: 'All' }, ...teams]}
            label="Team"
            fullWidth
            selectedDetails={selectedTeam}
            setChange={setSelectedTeam}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default MonthlyWiseGlobalFilter;
